const KAIZENREPORTING = "kaizenreporting"
const SINGLERULEBOOK = "singlerulebook"

const dictionary = new Proxy(
  {
    [KAIZENREPORTING]: {
      color: "#006be6",
      title: "Kaizen",
      logo: "/public/images/themes/kr/dda76e37b5ca2ba277e4ab539847a911.Logo.svg",
      favicon:
        "/public/images/themes/kr/9b4582bfd9c13d5d220039841944dc10.favicon.ico",
    },
    [SINGLERULEBOOK]: {
      color: "#e86447",
      title: "Single Rulebook",
      logo: "/public/images/themes/srb/3bc11e1bbc1ca935c0fe72a39b90a970.Logo.svg",
      favicon:
        "/public/images/themes/srb/9ca094e53e02ad45600d5989717f7d0b.favicon.ico",
    },
  },
  {
    get: (target, prop) =>
      target[prop] || {
        color: "#006be6",
        title: "Kaizen",
        logo: "/public/images/themes/kr/dda76e37b5ca2ba277e4ab539847a911.Logo.svg",
        favicon:
          "/public/images/themes/kr/9b4582bfd9c13d5d220039841944dc10.favicon.ico",
      },
  }
)

export default dictionary
